import React from 'react';
import { Route } from 'react-router-dom';
import { PublicSitePage } from './PublicSitePage';

export const routes = [<Route key="0" path="/public-site" component={PublicSitePage} />];

export const navigation = { name: 'public_site', link: '/public-site', icon: 'Contact', parent: 'BoardMembers' };
